import PropTypes from "prop-types";

export default function CollapsibleCard({
    title,
    subtitle = "",
    indicator = null,
    collapsed = false,
    onToggle = () => {},
    children = null,
    className = "",
    bodyClassName = "",
    testId = "collapsible-card",
    showToggle = true,
}) {
    const shellPadding = collapsed ? "px-3 sm:px-4 py-0" : "p-4 sm:p-5";
    const headerMinHeight = collapsed ? "min-h-[1.4rem]" : "min-h-[2.5rem]";
    const collapsedHeaderClassName =
        "nebula-card-header--collapsed py-0.5 sm:py-1 min-h-[1.5rem]";
    const headerClassName = `flex items-center justify-between gap-4 ${collapsed ? collapsedHeaderClassName : ""}`;
    const titleWrapperClassName = `${headerMinHeight} flex flex-col justify-center ${collapsed ? "leading-tight" : ""}`;

    return (
        <section
            className={`nebula-collapsible-card bg-gray-900/80 border border-gray-800 rounded-2xl shadow-xl ${shellPadding} ${className}`}
            data-collapsed={collapsed ? "true" : "false"}
            data-testid={testId}
        >
            <div className={headerClassName} data-testid={`${testId}-header`}>
                <div className={titleWrapperClassName}>
                    {subtitle && (
                        <p className="text-[0.65rem] uppercase tracking-wide text-gray-400">{subtitle}</p>
                    )}
                    <h2
                        className={`text-lg font-semibold text-white nebula-card-title ${collapsed ? "leading-[1.15]" : ""}`}
                    >
                        {title}
                    </h2>
                </div>
                <div className="flex items-center gap-3 text-xs">
                    {indicator}
                    {showToggle && (
                        <button
                            type="button"
                            className="px-2 py-1 rounded-full border border-purple-400/60 text-purple-100 uppercase tracking-wide"
                            onClick={onToggle}
                            aria-expanded={!collapsed}
                            aria-controls={`${testId}-body`}
                            data-testid={`${testId}-toggle`}
                        >
                            {collapsed ? "Expand" : "Collapse"}
                        </button>
                    )}
                </div>
            </div>
            <div
                id={`${testId}-body`}
                data-testid={`${testId}-body`}
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    collapsed ? "max-h-0 opacity-0 pointer-events-none" : "max-h-[2000px] opacity-100"
                }`}
                aria-hidden={collapsed}
            >
                <div className={`pt-4 ${bodyClassName}`}>{children}</div>
            </div>
        </section>
    );
}

CollapsibleCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    indicator: PropTypes.node,
    collapsed: PropTypes.bool,
    onToggle: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    testId: PropTypes.string,
    showToggle: PropTypes.bool,
};

